<template>
  <div class="web-box-all">
    <ext-header select_menu="9"></ext-header>

    <div class="web-home-main">

      <div class="web-order-box">
        <div class="web-order-left">
          <ext-nav></ext-nav>
        </div>
        <div class="web-order-right">
          <div class="web-user-title">
            <p><i></i>我的弗兰卡 > 联系客服</p>
          </div>

          <div class="web-customer-service">
            <img src="@/assets/goods_load.png" v-real-img="web_url+app_info.app_qrcode"/>
            <ul>
              <li><p>如有疑问请联系客服</p></li>
              <li><p>热线电话：<span>{{app_info.company_tel}}</span></p></li>
              <li><p>邮箱：{{app_info.company_email}}</p></li>
              <li><p>微信客服： {{app_info.wx_user_no}}</p></li>
            </ul>
          </div>
        </div>
      </div>

    </div>

    <div class="web-home-line"></div>

    <ext-footer></ext-footer>

  </div>
</template>
<script>
import ExtHeader from '@/components/header/index'
import ExtFooter from '@/components/footer/index'
import ExtNav from '@/components/leftnav/index'
import {getUserId, ajax, Encrypt, Decrypt, webUrl} from '@/utils/extend'

export default {
  name: 'customer_service',
  components: {
    'ext-header': ExtHeader,
    'ext-footer': ExtFooter,
    'ext-nav': ExtNav
  },
  data () {
    return {
      title: '联系客服',
      web_url: webUrl(),
      app_info: {
        app_qrcode: '',
        company_tel: '',
        company_email: '',
        wx_user_no: ''
      }
    }
  },
  mounted () {
    this.load_data()
  },
  methods: {
    load_data () {
      var that = this
      var type = this.type
      ajax({
        url: '/store/user/get_customer_service',
        method: 'post',
        data: {
          uid: getUserId(),
          type: type
        }
      }, function (ret) {
        if (ret && ret.code === 'success') {
          that.app_info = ret.data
        } else {
          that.app_info = []
        }
      })
    }
  }
}
</script>
<style scoped>
header,section,footer,div,ul,ol,li,img,a,span,em,del,legend,center,strong,var,fieldset,form,label,dl,dt,dd,cite,input,hr,time,mark,code,figcaption,figure,textarea,h1,h2,h3,h4,h5,h6,p{
    display:-moz-box;
    display: box;
    display: -webkit-box;
    font-family: "Noto Sans SC";
    display: inline-flex;
}

a { text-decoration:none; }
input { box-sizing:border-box;outline:none;}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {-webkit-appearance: none;}
input[type='number'] {-moz-appearance: textfield;}

.web-box-all { width:100%; height:auto; flex-wrap:wrap; align-content:flex-start;}
.web-home-main { width:1000px; height:auto; margin:0px auto; flex-wrap:wrap; align-content:flex-start;}
.web-home-line { width:100%; height:70px; }

.web-order-box { width:100%; height:auto; flex-flow:row; align-content:flex-start; margin-top:20px;}
  .web-order-left { width:200px; height:auto; margin-right:15px; flex-wrap:wrap; align-content:flex-start;}

  .web-order-right { width:785px; height:auto; flex-wrap:wrap; align-content:flex-start;}

    .web-user-title { width:100%; height:40px;flex-flow:row; align-content:flex-start;}
      .web-user-title p { width:auto; height:40px; position: relative; padding:0px 20px; line-height:40px; font-size:14px; color:#333333;}
      .web-user-title p i { width:2px; height:20px; float: left; background: #d81e06; position: absolute; top:10px; left:10px;}

.web-customer-service { width:100%; height:376px; margin-top:15px; border:1px solid #dfdfdf;  padding:15px; flex-wrap:wrap; align-content:flex-start;}
  .web-customer-service img { width:140px; height:140px;}
  .web-customer-service ul { width:100%; height:auto; margin-top:20px; margin:0px 0px 0px 10px; padding:0px; list-style:none; flex-wrap:wrap; align-content:flex-start;}
  .web-customer-service ul li { width:100%; height:40px;flex-flow:row; margin:0px; padding:0px; align-content:flex-start;}
  .web-customer-service ul li p { width:100%; height:40px; margin:0px; padding:0px; line-height:40px; font-size:14px; color:#333333;}
  .web-customer-service ul li p span { color:#d81e06;}

</style>



// WEBPACK FOOTER //
// src/pages/store/customer_service.vue